export function initPageHeader() {
  const header = document.querySelector(".page-header");
  const toggle = header?.querySelector(".page-header__toggle");

  if (!header || !toggle) {
    return;
  }

  toggle.addEventListener("click", () => {
    const open = header.classList.toggle("is-nav-open");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  });
}
